module.exports = __webpack_public_path__ + "img/marco_s.366ff7d4.png";